var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18C16.3022 18 16.1089 18.0586 15.9444 18.1685C15.78 18.2784 15.6518 18.4346 15.5761 18.6173C15.5004 18.8 15.4806 19.0011 15.5192 19.1951C15.5578 19.3891 15.653 19.5673 15.7929 19.7071C15.9327 19.847 16.1109 19.9422 16.3049 19.9808C16.4989 20.0194 16.7 19.9996 16.8827 19.9239C17.0654 19.8482 17.2216 19.72 17.3315 19.5556C17.4414 19.3911 17.5 19.1978 17.5 19C17.5 18.7348 17.3946 18.4804 17.2071 18.2929C17.0196 18.1054 16.7652 18 16.5 18ZM20.5 20H34.5C34.7652 20 35.0196 19.8946 35.2071 19.7071C35.3946 19.5196 35.5 19.2652 35.5 19C35.5 18.7348 35.3946 18.4804 35.2071 18.2929C35.0196 18.1054 34.7652 18 34.5 18H20.5C20.2348 18 19.9804 18.1054 19.7929 18.2929C19.6054 18.4804 19.5 18.7348 19.5 19C19.5 19.2652 19.6054 19.5196 19.7929 19.7071C19.9804 19.8946 20.2348 20 20.5 20ZM20.5 23C20.3022 23 20.1089 23.0586 19.9444 23.1685C19.78 23.2784 19.6518 23.4346 19.5761 23.6173C19.5004 23.8 19.4806 24.0011 19.5192 24.1951C19.5578 24.3891 19.653 24.5673 19.7929 24.7071C19.9327 24.847 20.1109 24.9422 20.3049 24.9808C20.4989 25.0194 20.7 24.9996 20.8827 24.9239C21.0654 24.8482 21.2216 24.72 21.3315 24.5556C21.4414 24.3911 21.5 24.1978 21.5 24C21.5 23.7348 21.3946 23.4804 21.2071 23.2929C21.0196 23.1054 20.7652 23 20.5 23ZM24.5 28C24.3022 28 24.1089 28.0586 23.9444 28.1685C23.78 28.2784 23.6518 28.4346 23.5761 28.6173C23.5004 28.8 23.4806 29.0011 23.5192 29.1951C23.5578 29.3891 23.653 29.5673 23.7929 29.7071C23.9327 29.847 24.1109 29.9422 24.3049 29.9808C24.4989 30.0194 24.7 29.9996 24.8827 29.9239C25.0654 29.8482 25.2216 29.72 25.3315 29.5556C25.4414 29.3911 25.5 29.1978 25.5 29C25.5 28.7348 25.3946 28.4804 25.2071 28.2929C25.0196 28.1054 24.7652 28 24.5 28ZM34.5 23H24.5C24.2348 23 23.9804 23.1054 23.7929 23.2929C23.6054 23.4804 23.5 23.7348 23.5 24C23.5 24.2652 23.6054 24.5196 23.7929 24.7071C23.9804 24.8946 24.2348 25 24.5 25H34.5C34.7652 25 35.0196 24.8946 35.2071 24.7071C35.3946 24.5196 35.5 24.2652 35.5 24C35.5 23.7348 35.3946 23.4804 35.2071 23.2929C35.0196 23.1054 34.7652 23 34.5 23ZM34.5 28H28.5C28.2348 28 27.9804 28.1054 27.7929 28.2929C27.6054 28.4804 27.5 28.7348 27.5 29C27.5 29.2652 27.6054 29.5196 27.7929 29.7071C27.9804 29.8946 28.2348 30 28.5 30H34.5C34.7652 30 35.0196 29.8946 35.2071 29.7071C35.3946 29.5196 35.5 29.2652 35.5 29C35.5 28.7348 35.3946 28.4804 35.2071 28.2929C35.0196 28.1054 34.7652 28 34.5 28Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_919",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.317647 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_919",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.6e73cec58967318bd94545c060a3c6b4.svg";
export { ForwardRef as ReactComponent };